import {endpoint} from "@/utils/api/Conf";
import {Place, PlaceCategories, PlaceCategory, PlaceType, PlaceTypes} from "@/types/Places";

export const placeRequest = async (placeId: string): Promise<Place | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
    }
    return await fetch(endpoint + `places/${placeId}`, init)
      .then((response) => response.json())
      .then((data: Place) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};

export const placeCategoryRequest = async (catId: string): Promise<PlaceCategory | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
    }
    return await fetch(endpoint + `place-categories/${catId}`, init)
      .then((response) => response.json())
      .then((data: PlaceCategory) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};

export const placeTypeRequest = async (typeId: string): Promise<PlaceType | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
    }
    return await fetch(endpoint + `place-types/${typeId}`, init)
      .then((response) => response.json())
      .then((data: PlaceType) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};

export const placeTypesRequest = async (): Promise<PlaceTypes | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
    }
    return await fetch(endpoint + `place-types?page_size=50`, init)
      .then((response) => response.json())
      .then((data: PlaceTypes) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};

export const placeCategoriesRequest = async (): Promise<PlaceCategories | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
    }
    return await fetch(endpoint + `place-categories?page_size=50`, init)
      .then((response) => response.json())
      .then((data: PlaceCategories) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
